//Möchten Sie wirklich die Akte neu anlegen?

import { Component, inject, Input, input } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { RestClient } from "../../../Api/DcoApi/Client/RestClient";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'ngbd-modal-confirm-autofocus',
  imports: [
    CommonModule,
    FormsModule
  ],
  template: `
		<div class="modal-header">
			<h4 class="modal-title" id="modal-title"></h4>
			<button
				type="button"
				class="btn-close"
				aria-label="Close button"
				aria-describedby="modal-title"
				(click)="modal.dismiss(false)"
			></button>
		</div>
		<div class="modal-body">
			 <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Mail" [(ngModel)]="Mail">
        <label for="Mail">Mail</label>
      </div>
		</div>
		<div class="modal-footer">
    	<button type="button" ngbAutofocus class="btn btn-success" (click)="SendMail()">Senden</button>
			<button type="button" class="btn btn-danger" (click)="modal.dismiss(false)">Abbrechen</button>
		</div>
	`,
})
export class EmailDialog {
  readonly modal = inject(NgbActiveModal);
  @Input() trackingnummer: string = "";
  Client: RestClient = new RestClient();

  @Input() Mail: string = "";
  @Input() isVersand: boolean = false;

  async SendMail() {

    if (this.Mail && this.Mail != "") {
      await this.Client.Get(`/Backend/Api/V2/VersandAuftraege/${this.trackingnummer}/${(this.isVersand ? 'SendTrackingMail' : 'SendReturnMail')}/${this.Mail}`);
    }

    this.modal.close(true);
  }

}
